import {
  useListActiveSocialsQuery,
  useListActiveProfessionalQuery,
  useListSocialsForCongressIdQuery,
  useListProfessionalForCongressIdQuery,
} from "../store/activity/activity";
import { Activity } from "../types/activity.types";

interface UseProgramsQueryResult {
  socialList: Activity[];
  professionalList: Activity[];
  areSocialsLoading: boolean;
  areProfessionalsLoading: boolean;
}

export const useProgramsQuery = (
  congressId: number,
  isEditMode: boolean
): UseProgramsQueryResult => {
  const socialsPublicQuery = useListActiveSocialsQuery(congressId, {
    skip: isEditMode,
  });
  const socialsHiddenQuery = useListSocialsForCongressIdQuery(congressId, {
    skip: !isEditMode,
  });

  const professionalsPublicQuery = useListActiveProfessionalQuery(congressId, {
    skip: isEditMode,
  });
  const professionalsHiddenQuery = useListProfessionalForCongressIdQuery(
    congressId,
    {
      skip: !isEditMode,
    }
  );

  const socialList = isEditMode
    ? socialsHiddenQuery.data ?? []
    : socialsPublicQuery.data ?? [];
  const professionalList = isEditMode
    ? professionalsHiddenQuery.data ?? []
    : professionalsPublicQuery.data ?? [];

  const areSocialsLoading = isEditMode
    ? socialsHiddenQuery.isLoading
    : socialsPublicQuery.isLoading;
  const areProfessionalsLoading = isEditMode
    ? professionalsHiddenQuery.isLoading
    : professionalsPublicQuery.isLoading;

  return {
    socialList,
    professionalList,
    areSocialsLoading,
    areProfessionalsLoading,
  };
};
